import helpers from '../helpers';
import verifiers from '../verifiers';

class HSLColor {
  constructor(hue, saturation, lightness, alpha = 1) {
    this.hue = hue;
    this.saturation = saturation;
    this.lightness = lightness;
    this.alpha = alpha;
    helpers.checkRange(hue, 360, 'hue');
    helpers.checkRange(saturation, 1, 'saturation');
    helpers.checkRange(lightness, 1, 'lightness');
    helpers.checkRange(alpha, 1, 'alpha');
  }

  equals({ hue, saturation, lightness, alpha }, checkAlpha = true) {
    if (lightness === this.lightness && (lightness === 0 || lightness === 1)) return true;

    const { isShadesEqual } = verifiers;
    const checkH = isShadesEqual(this.hue, hue);
    const checkS = isShadesEqual(this.saturation, saturation);
    const checkL = isShadesEqual(this.lightness, lightness);

    if (checkS && checkL && (saturation <= 0.01 || lightness <= 0.01)) return checkS && checkL;
    // when saturation or lightness are to small (less than 1%) changing of a hue does not affect on the resulting color
    // so in that case we should not compare hue
    const hslCondition = checkH && checkS && checkL;

    if (checkAlpha) return hslCondition && isShadesEqual(this.alpha, alpha);
    return hslCondition;
  }

  strictlyEquals({ hue, saturation, lightness, alpha }, checkAlpha = true) {
    const hslCondition =
      this.hue === hue && this.saturation === saturation && this.lightness === lightness;
    if (checkAlpha) return hslCondition && this.alpha === alpha;
    return hslCondition;
  }

  setAlpha(alpha) {
    this.alpha = alpha;
    helpers.checkRange(alpha, 1, 'alpha');
  }

  setLightness(lightness) {
    this.lightness = lightness;
    helpers.checkRange(lightness, 1, 'lightness');
  }

  getLightness() {
    return this.lightness;
  }

  getAlpha() {
    return (this.alpha * 100).toFixed() / 100;
  }

  toCSSValue() {
    const h = helpers.roundsDecimals(this.hue);
    const s = helpers.roundsDecimals(100 * this.saturation);
    const l = helpers.roundsDecimals(100 * this.lightness);

    return `hsla(${h}, ${s}%, ${l}%, ${this.alpha})`;
  }

  toColorString() {
    const fixedH = this.hue.toFixed();
    const fixedS = (100 * this.saturation).toFixed();
    const fixedL = (100 * this.lightness).toFixed();

    return `${fixedH}, ${fixedS}%, ${fixedL}%`;
  }

  rotate(hueAdjustment) {
    return new HSLColor(
      (this.hue + hueAdjustment + 360) % 360,
      this.saturation,
      this.lightness,
      this.alpha
    );
  }
}

export default HSLColor;
